var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{class:_vm.$style.field,attrs:{"value":_vm.val,"size":"small","type":"text"},on:{"input":_vm.onType}})
}
var staticRenderFns = []

export { render, staticRenderFns }